import { Dialog, DialogContent, DialogActions, Typography, Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { CustomButton } from '../';

const InfoDialog = ({
  open,
  onClose,
  title = 'Información',
  message,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
        },
      }}
    >
      <DialogContent sx={{ textAlign: 'center', py: 4 }}>
        <Box sx={{ mb: 2 }}>
          <InfoOutlinedIcon
            sx={{
              fontSize: 60,
              color: 'info.main',
              mb: 2,
            }}
          />
        </Box>

        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
          {title}
        </Typography>

        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, justifyContent: 'center' }}>
        <CustomButton onClick={onClose} variant="base">
          Entendido
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default InfoDialog;
